export default "__VITE_ASSET__DCnpW7do__"